import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';
import imageCompression from 'browser-image-compression';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faSearch, faPlus, faFilter, faChevronLeft, faCircle, faFlag, faCar, faCamera } from '@fortawesome/free-solid-svg-icons'

import Preview from '../../../components/preview.js';

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Передача техніки',
        filter: 'Стан:',
        all: 'Всі',
        state08: 'Створені',
        state23: 'Анульовані',
        state45: 'Відхилені',
        state42: 'Виконати при наступному ТО',
        state51: 'Заплановані',
        state13: 'Виконані',
        searchText: 'Пошук...',
        noData: 'Данi вiдсутнi',
        edit: 'Редагувати',
        cancel: 'Анулювати',
    },
    ru: {
        title: 'Передача техники',
        filter: 'Состояние:',
        all: 'Все',
        state08: 'Созданные',
        state23: 'Аннулированные',
        state45: 'Отклоненные',
        state42: 'Выполнить при следующем ТО',
        state51: 'Запланированные',
        state13: 'Выполненные',
        searchText: 'Поиск...',
        noData: 'Нет данных',
        edit: 'Редактировать',
        cancel: 'Аннулировать',
    },
    en: {
        title: 'Transfer of equipment',
        filter: 'Стан:',
        all: 'All',
        state08: 'Створено',
        state23: 'Анульовано',
        state45: 'Відхилено',
        state42: 'Виконати при наступному ТО',
        state51: 'Заплановано',
        state13: 'Виконано',
        searchText: 'Filter...',
        noData: 'No data',
        edit: 'Edit',
        cancel: 'Cancel',
    },
}

class ServiceTransfer extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,
            redirect: null,

            searchText: '',

            rows: [],
        }

        this.searchTextChange = this.searchTextChange.bind(this);
        this.searchTextKeyPress = this.searchTextKeyPress.bind(this);
        this.ready = this.ready.bind(this);
        this.cancel = this.cancel.bind(this);
        this.accept = this.accept.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.loadList();
    }

    loadList() {
        const {addNotification, removeNotification, token} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/transfer/list', { token: token, did: 0 }).then((res) => {
                this.setState({
                    isLoading: false,
                    rows: res.data.rows, 
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                rows: [
                    {
                        did: 1,
                        date: "2018-07-24 09:51",
                        number: "453",
                        status: "Анульований",
                        state: 8,
                        truck: "Seat Altea3",
                        truckNumber: "AA 1234 AA",
                        trailer: "3434",
                        trailerNumber: "AA 1234 AA",
                        mileage: "13",
                        driverFromID: 1,
                        driverFromName: "Юра",
                        driverFromPhone: "+380508673516",
                        driverFromDate: "2018-07-24 09:51",
                        driverToID: 1,
                        driverToName: "Саша",
                        driverToPhone: "+380503456751",
                        driverToDate: "2018-07-24 09:51",
                        remark: "Car is broken, IDK why",
                        acceptFrom: 0,
                        acceptTo: 0,
                    },
                    {
                        did: 2,
                        date: "2018-07-24 09:51",
                        number: "453",
                        status: "Відхилений",
                        state: 9,
                        truck: "Seat Altea3",
                        truckNumber: "AA 1234 AA",
                        trailer: "3434",
                        trailerNumber: "AA 1234 AA",
                        mileage: "13",
                        driverFromID: 1,
                        driverFromName: "Юра",
                        driverFromPhone: "+380508673516",
                        driverFromDate: "2018-07-24 09:51",
                        driverToID: 1,
                        driverToName: "Саша",
                        driverToPhone: "+380503456751",
                        driverToDate: "2018-07-24 09:51",
                        remark: "Car is broken, IDK why",
                        acceptFrom: 0,
                        acceptTo: 1,
                    },
                    {
                        did: 3,
                        date: "2018-07-24 09:51",
                        number: "453",
                        status: "Виконати при наступному ТО",
                        state: 13,
                        truck: "Seat Altea3",
                        truckNumber: "AA 1234 AA",
                        trailer: "3434",
                        trailerNumber: "AA 1234 AA",
                        mileage: "13",
                        driverFromID: 1,
                        driverFromName: "Юра",
                        driverFromPhone: "+380508673516",
                        driverFromDate: "2018-07-24 09:51",
                        driverToID: 1,
                        driverToName: "Саша",
                        driverToPhone: "+380503456751",
                        driverToDate: "2018-07-24 09:51",
                        remark: "Car is broken, IDK why",
                        acceptFrom: 1,
                        acceptTo: 1,
                    },
                ]
            });
        }
    }
   
    searchTextChange(e) {
        this.setState({searchText: e.target.value});
    }
    
    searchTextKeyPress(e) {
        if (e.key === 'Enter') {
            e.target.blur();
        }
    }

    ready(did) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/ready', { 
            token: token, 
            did: did,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    cancel(did) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/cancel', { 
            token: token, 
            did: did,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    accept(did, accept) {
        const {addNotification, removeNotification, token, lang} = this.context;

        var u = addNotification("Завантаження...");
        axios.post('/api/service/transfer/accept', { 
            token: token, 
            did: did,
            accept: accept,
        }).then((res) => {
            if (res.data.serror == "") {
                this.loadList();
            } else {
                addNotification(res.data.serror, 2);
            }
        }).catch((error) => {
            addNotification(error.response.data, error.response.status);
        }).finally(function () {
            removeNotification(u);
        });
    }

    renderList() {
        const {lang} = this.context;

        if (this.state.rows.length === 0) {
            return (
                <div className="row">
                    <div className="col">
                        <div className="card agis-card">
                            <div className="row">
                                <div className="col" style={{display: "flex", alignItems: "center", height: "30px"}}>
                                    <div>
                                        <h6><b>{localization[lang].noData}</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return this.state.rows.filter((item, i) => {
                // check by text filter
                if ([item.number, item.date, item.status, item.truck, item.trailer, item.driverFromName, item.driverFromPhone, item.driverFromDate, item.driverToName, item.driverToPhone, item.driverToDate, item.remark].join(' ').toLowerCase().includes(this.state.searchText.toLowerCase())) {
                    return true;
                }

                return false;
            }).map((item, i) => {
                var statusColor = ""
                switch (item.state) {
                    case 9: 
                        statusColor = "text-info"
                        break
                    case 13: 
                        statusColor = "text-success"
                        break
                    case 23: 
                        statusColor = "text-warning"
                        break
                    case 40: 
                        statusColor = "text-danger"
                        break
                    default:
                        statusColor = ""
                }

                return (
                    <div className="row mb-2" key={"request_" + i}>
                        <div className="col">
                            <div className="card-agis pt-2 pb-2" style={{borderRadius: "15px", color: "#54585a"}}>
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                    <big><b>{item.number}</b> від {item.date}, <span className={statusColor}>{item.status}</span></big>
                                    {/* {item.state == 8 && (
                                        <button className="btn-agis-light-outline" style={{height: "40px", width: "40px", minWidth: "40px"}} onClick={() => {this.triggerFileInput(item.did)}}><FontAwesomeIcon icon={faCamera}/></button>
                                    )} */}
                                </div>
                                <div className='mt-2'>
                                    <big>{item.truck}</big>
                                </div>
                                <div>
                                    <big>{item.trailer}</big>
                                </div>
                                <div className='mt-2'>
                                    <big><b>{item.driverFromName}</b></big>
                                    {item.driverFromPhone != "" && (
                                        <big>, <a href={"tel:"+item.driverFromPhone}>{item.driverFromPhone}</a></big>
                                    )}
                                </div>
                                <div>
                                    {item.driverFromDate != "" && (
                                        <big>{item.driverFromDate}</big>
                                    )}
                                </div>
                                {item.acceptFrom != 0 && (
                                    <button className="btn-agis-primary-outline" onClick={() => this.accept(item.did, false)} style={{height: "30px", width: '48%', minWidth: "0px",}}>Здав</button>
                                )}

                                <div className='mt-3'>
                                    <big><b>{item.driverToName}</b></big>
                                    {item.driverToPhone != "" && (
                                        <big>, <a href={"tel:"+item.driverToPhone}>{item.driverToPhone}</a></big>
                                    )}
                                </div>
                                <div>
                                    {item.driverToDate != "" && (
                                        <big>{item.driverToDate}</big>
                                    )}
                                </div>
                                {item.acceptTo != 0 && (
                                    <button className="btn-agis-primary-outline" onClick={() => this.accept(item.did, true)} style={{height: "30px", width: '48%', minWidth: "0px"}}>Прийняв</button>
                                )}
                                {item.remark != "" && (
                                    <div className='mt-3'>
                                        <span>{item.remark}</span>
                                    </div>
                                )}

                                {item.state == 8 && (
                                    <div className="d-flex align-items-center justify-content-between mt-2 mb-2">
                                        <button className="btn-agis-light-outline" onClick={() => this.setState({redirect: '/service/transfer/' + item.did})} style={{height: "30px", width: '48%', minWidth: "0px", border: "1px solid #ebebeb"}}>Редагувати</button>
                                        <button className="btn-agis-light-outline" onClick={() => this.cancel(item.did)} style={{height: "30px", width: '48%', minWidth: "0px", border: "1px solid #ebebeb"}}>Анулювати</button>
                                    </div>
                                )}

                                {item.state == 8 && (
                                    <button className="btn-agis-light-outline" onClick={() => this.ready(item.did)} style={{height: "30px", width: '100%', minWidth: "0px", border: "1px solid #ebebeb"}}>Готовий до перерахунку</button>
                                )}

                                {item.state == 9 && (
                                    <button className="btn-agis-light-outline mt-2" onClick={() => this.cancel(item.did)} style={{height: "30px", width: '100%', minWidth: "0px", border: "1px solid #ebebeb"}}>Анулювати</button>
                                )}

                                <button className="btn-agis-light-outline mt-2" onClick={() => this.setState({redirect: '/service/transfer/card/' + item.did})} style={{height: "30px", width: '100%', minWidth: "0px", border: "1px solid #ebebeb"}}>Детальніше</button>
                            </div>
                        </div>
                    </div>
                );
            });
        }
    }

    render() {
        const {lang, access} = this.context;

        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                {/* INPUT FILE UPLOAD */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">
                                <div className="d-flex justify-content-between mb-3">
                                    <input id="searchInput" type="text" className="question-input" style={{height: "40px", width: "100%", fontSize: "16px", borderRadius: "10px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", backgroundColor: "#fff"}} placeholder={localization[lang].searchText} value={this.state.searchText} onChange={(e) => this.searchTextChange(e)} onKeyPress={(e) => this.searchTextKeyPress(e)} />
                                    <button onClick={this.searchCodeButtonClick} className="a-agis-light-outline" style={{height: '40px', width: "40px", minWidth: "0px", borderRadius: "10px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", lineHeight: "34px", backgroundColor: "white", border: "1px solid #ebebeb", boxShadow: "0 0 0 1px rgba(0,0,0,.05), 0 2px 3px 0 rgba(0,0,0,.1)"}}><FontAwesomeIcon icon={faSearch} style={{fontSize: "20px"}} /></button>
                                </div>

                                {this.renderList()}

                                <div className="fixed-bottom text-right" style={{zIndex: "4", paddingRight: "10px", paddingBottom: "10px", height: "60px"}}>
                                    <Link to={"/service/transfer/new"} className="a-agis-light-outline" style={{height: '50px', width: "50px", minWidth: "0px", borderRadius: "25px", lineHeight: "44px", backgroundColor: "#1a73e8", color: "white", border: "1px solid #ebebeb", boxShadow: "0 1px 1px rgba(0,0,0,.15)"}}><FontAwesomeIcon icon={faPlus} style={{fontSize: "20px"}} /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ServiceTransfer;